export default "__VITE_ASSET__Myp9eAQ6__"